<template>
    <link-company-invenias :company="company" @close="Close" v-if="type == 'invenias'"></link-company-invenias>
    <link-company-mcl :invenias-company="company" @close="Close" v-else></link-company-mcl>
</template>
<script>
    import { ref, computed, inject, watch, onMounted } from "vue";
    import linkCompanyInvenias from "@/components/modals/invenias/link-company/invenias/link-company-invenias.vue";
    import linkCompanyMcl from "@/components/modals/invenias/link-company/mcl/link-company-mcl.vue";

    export default {
        components: {
            linkCompanyInvenias,
            linkCompanyMcl
        },
        props: {
            company: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            type: {
                type: String,
                default: "invenias"
            }
        },
        emits: ["close"],
        setup(props, context) {

            const Close = (result) => {
                context.emit("close", result);
            };

            return {
                Close
			};
		}
	};
</script>
